module.exports = __webpack_public_path__ + "img/default-avatar.4ab6dd8c.svg";